import React, { useState } from 'react';
import { Send, Heart } from 'lucide-react';

interface GuestMessagesProps {
  invitationId: string | null;
  isLive: boolean;
  language: 'en' | 'mr';
  onMessageAdded: () => void;
  totalMessages: number;
}

export const GuestMessagesSection: React.FC<GuestMessagesProps> = ({
  invitationId,
  isLive,
  language,
  onMessageAdded,
  totalMessages,
}) => {
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim() || !message.trim()) return;

    setName('');
    setMessage('');
    onMessageAdded();
  };

  return (
    <section className="relative py-24 px-4">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-center text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-blue-400 mb-4">
          {language === 'mr' ? '💌 आशीर्वाद पाठवा' : '💌 Send Your Wishes'}
        </h2>
        <p className="text-center text-gray-400 mb-12">
          {language === 'mr' ? `${totalMessages} संदेश` : `${totalMessages} wishes so far`}
        </p>

        <form onSubmit={handleSubmit} className="mb-12 bg-gradient-to-br from-slate-900/50 to-slate-800/50 border border-blue-400/30 rounded-2xl p-8">
          <div className="space-y-4">
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder={language === 'mr' ? 'नाव' : 'Your name'}
              className="w-full bg-slate-800 border border-slate-700 text-white rounded-lg px-4 py-3 focus:border-blue-400 focus:ring-2 focus:ring-blue-400/20 transition-all"
            />

            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder={language === 'mr' ? 'आपला संदेश...' : 'Your farewell message...'}
              rows={3}
              className="w-full bg-slate-800 border border-slate-700 text-white rounded-lg px-4 py-3 focus:border-pink-400 focus:ring-2 focus:ring-pink-400/20 transition-all resize-none"
            />

            <button
              type="submit"
              className="w-full bg-gradient-to-r from-blue-500 to-pink-500 text-white font-bold py-3 rounded-lg hover:shadow-lg transition-all flex items-center justify-center gap-2"
            >
              <Send size={18} />
              {language === 'mr' ? 'पाठवा' : 'Send'}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};
